export default __webpack_public_path__ + "static/media/021-u.d663299c.svg";